/* For Browser Compatibility */

// Defense-in-depth runtime globals — @rollup/plugin-inject in vite.config.js
// is the primary mechanism. This covers libraries that read globalThis.Buffer
// or window.Buffer directly rather than as a bare identifier.
import { Buffer } from "buffer";
import process from "process";

/* Needed by IE, if we stop supporting it, this can be removed */
import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/array/from";

declare global {
  var Buffer: typeof import("buffer").Buffer;

  var process: NodeJS.Process;
}

if (typeof globalThis.Buffer === "undefined") globalThis.Buffer = Buffer;
if (typeof globalThis.process === "undefined")
  globalThis.process = process as unknown as NodeJS.Process;
